import { __rest } from "tslib";
import React from 'react';
import { error } from '../../utils/console';
function createContext(rootComponentName, defaultContext) {
    const Context = React.createContext(defaultContext);
    function Provider(props) {
        const { children } = props, context = __rest(props, ["children"]);
        const value = React.useMemo(() => context, Object.values(context));
        return React.createElement(Context.Provider, { value: value }, children);
    }
    function useContext(consumerName) {
        const context = React.useContext(Context);
        if (context)
            return context;
        if (defaultContext !== undefined)
            return defaultContext;
        throw error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Context.displayName = rootComponentName + 'Context';
    Provider.displayName = rootComponentName + 'Provider';
    return [Provider, useContext];
}
export default createContext;
//# sourceMappingURL=context.js.map